class ProductSearch {
    constructor(productData) {
        this.productData = productData;
    }

    // Method to find options (option1 and option2) based on variant ID
    findOptionsByVariantId(variantId) {
        console.log(this.productData)
        const variant = this.productData.variants.find(v => v.id == variantId);
        if (variant) {
            return {
                id:this.productData.id,

                option1: variant.option1,
                option2: variant.option2,
                qty:0,
                variantId:variant.id,
            };
        }
        return null; // Variant ID not found
    }

    // Method to find variant ID based on options (option1 and optionally option2)
    findVariantIdByOptions(option1, option2) {
        const variant = this.productData.variants.find(v => {            
            if (option2!="undefined") {
                return v.option1 == option1 && v.option2 == option2;
            } else {
                return v.option1 == option1;
            }
        });
        console.log(variant);
        return variant ? variant.id : null; // Return variant ID or null if not found
    }
}

window.ProductSearch = ProductSearch;